import React, { useMemo } from 'react';
import './ProjectCard.less';
import RenderingImage from './common/RenderingImage';
import moment from 'moment';

const projectRoles = [
  {name: 'head', ruName: 'Руководитель'},
  {name: 'admin', ruName: 'Администратор'},
  {name: 'curator', ruName: 'Куратор'},
  {name: 'coordinator', ruName: 'Координатор'},
]
export default function ProjectCard(props) {
  const {
    logo, name, num, users, isArchived, endDate, type,
  } = props.data;
  
  const { minHeaderHeight } = props;

  // Элегантное решение для поднятия человека в списке отображаемых персон
  users.sort((a, b) => {
    if (a.displayName == "Князев Сергей Тихонович") return -1;
    if (b.displayName == "Князев Сергей Тихонович") return 1;
    return 0;
  })

  const usersByRoles = useMemo(() => users.reduce((acc, curr) => {
    const usersByRole = acc[curr.role] || [];
    return {...acc, [curr.role]: usersByRole.some(user => user.userId === curr.userId) ? usersByRole : [...usersByRole, curr]}
  }, {}), [users])

  return (
    <div onClick={props?.onClick} className="project-card">
      <div className="project-card-heading" style={{
          height: users.length > 0 ? 'max-content' : '100%',
          minHeight: `${minHeaderHeight}px`
        }}>
        <div className='project-card-name'>
          <p className="num">{num}</p>
          <p className="title">{name}</p>
        </div>
        {isArchived && <p className='project-card-endDate'>Дата окончания{type !== 'policy' ? ' проекта' : ''}: {endDate ? moment(endDate).format('DD.MM.YYYY') : 'Не указано'}</p>}
      </div>
      {users.length > 0 && <div className="project-card-body">
        {projectRoles.map((role) => usersByRoles[role.name]?.length > 0 &&
            <React.Fragment key={role.name}>
              <b>{role.ruName}</b>
              <div className="job">
                {usersByRoles[role.name].map((user, i) => <div className="person-wrapper" key={i}>
                  <div className="user-img"><RenderingImage userId={user.sAMAccountName} url={user.avatars.preview} /></div>
                  <p className="fio">{user.displayName}</p>
                </div>)}
              </div>
            </React.Fragment>
          )
        }
      </div>}
    </div>
  );
}
